import React, { useState } from 'react';
import {
	makeStyles,
	MenuItem,
	FormControlLabel,
	useMediaQuery,
	Select,
	ListItemText,
} from '@material-ui/core';
const useStyles = makeStyles((theme) => ({
	root: {
		minHeight: 25,
		whiteSpace: 'nowrap',
		textOverflow: 'ellipsis',
		overflow: 'hidden',
		padding: '5.5px 14px',
		display: 'flex',
		alignItems: 'center',
	},
	container: {
		placeItems: 'normal',
		maxWidth: ({ isMobile }) => isMobile && '100%',
		width: ({ isMobile, width }) => (isMobile ? '100%' : width),
		margin: 0,
	},
	label: {
		minWidth: 120,
		marginRight: 10,
		color: ({ disabled, touched, hover }) =>
			(touched || hover) && !disabled ? theme.palette.primary.main : 'black',
	},
}));

const SimpleDropdown = ({
	label,
	name,
	onChange,
	value,
	options = [],
	width = '100%',
	disabled,
	labelPos = 'top',
	style = {},
	containerClass = '',
	multiple = false,
	autoFocus = false,
}) => {
	const isMobile = useMediaQuery('(max-width: 768px)');
	const [touched, setTouched] = useState(false);
	const [hover, setHover] = useState(false);
	const classes = useStyles({ isMobile, width, disabled, touched, hover });

	return (
		<FormControlLabel
			className={classes.container + ` ${containerClass}`}
			label={<p className={classes.label}>{label}</p>}
			labelPlacement={isMobile ? 'top' : labelPos}
			control={
				<Select
					autoFocus={autoFocus}
					fullWidth
					displayEmpty
					style={style}
					value={value}
					onChange={onChange}
					multiple={multiple}
					classes={{ root: classes.root }}
					variant="outlined"
					size="small"
					name={name}
					disabled={disabled}
					onMouseEnter={() => setHover(true)}
					onMouseLeave={() => setHover(false)}
					onBlur={() => setTouched(false)}
					onFocus={(e) => setTouched(true)}
					renderValue={(selected) => (
						<span className="text-truncate">
							{multiple
								? selected
										.map(
											(sel) =>
												options.find((op) => op.value === sel)
													?.text
										)
										.join(', ')
								: options.find((op) => op.value === selected)?.text}
						</span>
					)}
				>
					<MenuItem value="">Seleccione una opción</MenuItem>
					{options.map(
						(option) =>
							option && (
								<MenuItem
									key={
										option.value?.id ? option.value?.id : option.value
									}
									value={option.value}
									disabled={option.disabled}
								>
									<ListItemText
										className="d-flex align-items-end"
										primary={option.text}
										secondary={option.text2}
										secondaryTypographyProps={{ className: 'ml-3' }}
									/>
								</MenuItem>
							)
					)}
				</Select>
			}
		/>
	);
};

export default SimpleDropdown;
